import { render, staticRenderFns } from "./NETVSHub.vue?vue&type=template&id=5d928439&scoped=true"
import script from "./NETVSHub.vue?vue&type=script&lang=js"
export * from "./NETVSHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d928439",
  null
  
)

export default component.exports